import types from './types'

export const providerList = (payload) => ({ type: types.PROVIDERS_LIST, payload })
export const providerListRes =(payload) => ({ type: types.PROVIDERS_LIST_RESPONSE, payload })
export const providerListClear = (payload) => ({ type: types.PROVIDERS_LIST_CLEAR })
export const providerCoursesList = (payload) => ({ type: types.PROVIDER_COURSES_LIST, payload })
export const providerCoursesListRes =(payload) => ({ type: types.PROVIDER_COURSES_LIST_RESPONSE, payload })
export const providerVideosList = (payload) => ({ type: types.PROVIDER_VIDEOS_LIST, payload })
export const providerVideosListRes =(payload) => ({ type: types.PROVIDER_VIDEOS_LIST_RESPONSE, payload })

export const providerCategoryList = (payload) => ({ type: types.PROVIDER_CATEGORY_LIST, payload })
export const providerCategoryListRes =(payload) => ({ type: types.PROVIDER_CATEGORY_LIST_RESPONSE, payload })

export const providerDetails = (payload) => ({ type: types.PROVIDER_DETAIL, payload })
export const providerDetailsRes =(payload) => ({ type: types.PROVIDER_DETAIL_RESPONSE, payload })
export const providerDetailsResClear = () => ({ type: types.PROVIDER_DETAIL_RESPONSE_CLEAR })

export const providerCoaching = (payload) => ({ type: types.PROVIDER_COACHING, payload })
export const providerCoachingRes =(payload) => ({ type: types.PROVIDER_COACHING_RESPONSE, payload })
export const providerCoachingClear =(payload) => ({ type: types.PROVIDER_COACHING_CLEAR, payload })


export const coachingDetail = (payload) => ({ type: types.COACHING_DETAIL, payload })
export const coachingDetailResponse =(payload) => ({ type: types.COACHING_DETAIL_RESPONSE, payload })
export const coachingDetailClear =(payload) => ({ type: types.COACHING_DETAIL_CLEAR, payload })

//Global Search Partners
export const getGlobalSearchPartners = (payload) => ({
    type: types.GLOBAL_SEARCH_PARTNERS,
    payload,
  });
  export const getGlobalSearchPartnersResponse = (payload) => ({
    type: types.GLOBAL_SEARCH_PARTNERS_RESPONSE,
    payload,
  });
  export const getGlobalSearchPartnersClear = () => ({
    type: types.GLOBAL_SEARCH_PARTNERS_CLEAR,
  });

  //Global Search Coaching
export const getGlobalSearchCoaching = (payload) => ({
    type: types.GLOBAL_SEARCH_COACHING,
    payload,
  });
  export const getGlobalSearchCoachingResponse = (payload) => ({
    type: types.GLOBAL_SEARCH_COACHING_RESPONSE,
    payload,
  });
  export const getGlobalSearchCoachingClear = () => ({
    type: types.GLOBAL_SEARCH_COACHING_CLEAR,
  });

